import { FC, MouseEvent } from "react";
import { Link, LinkProps } from "react-router-dom";
import { Button, Icons } from "rujira.ui";

export const PortfolioManageButton: FC<
  Pick<LinkProps, "to" | "relative">
> = ({ to, relative }) => (
  <td className="text-right portfolio__manage-action">
    <Button
      as={Link}
      to={to}
      relative={relative}
      onClick={(event: MouseEvent) => event.stopPropagation()}
      className="button--xs button--outline button--icon-right button--grey"
      label="Manage">
      <Icons.ArrowUpRight />
    </Button>
  </td>
);

export const PortfolioShareButtonPlaceholder: FC = () => (
  <td className="text-right portfolio__share-action">
    <span className="block w-3 h-3 ml-0.5" aria-hidden />
  </td>
);
